/**
 * Order for the "+" existing-property picker.
 * System properties (built-in file fields) come first, then AI properties
 * (extraction questions). Each group is alphabetical by the name shown.
 */
export interface ExistingPropertyOption {
  readonly colDef: {
    readonly headerName?: string;
  };
  readonly colOption: {
    readonly __typename: 'ExtractionReportColumn' | 'FileFieldColumn';
  };
}

export function sortExistingPropertyOptions<T extends ExistingPropertyOption>(
  options: readonly T[]
): T[] {
  const systemColumns: T[] = [];
  const aiColumns: T[] = [];

  for (const option of options) {
    switch (option.colOption.__typename) {
      case 'FileFieldColumn':
        systemColumns.push(option);
        break;
      case 'ExtractionReportColumn':
        aiColumns.push(option);
        break;
    }
  }

  systemColumns.sort(compareExistingPropertyNames);
  aiColumns.sort(compareExistingPropertyNames);

  return [...systemColumns, ...aiColumns];
}

function compareExistingPropertyNames(
  a: ExistingPropertyOption,
  b: ExistingPropertyOption
): number {
  return (a.colDef.headerName ?? '').localeCompare(b.colDef.headerName ?? '');
}
